module.exports = __webpack_public_path__ + "img/inspector_icon.3ddba9ce.png";